import React from "react";
import { IWidget } from "apiConsumers/newsApiConsumer/models/INewsArticle";
import YoutubeVideoWidget from "./widgets/YoutubeVideoWidget";
import TextBlockWidget from "./widgets/TextBlockWidget";
import ButtonsWidget from "./widgets/ButtonsWidget";
import HtmlWidget from "./widgets/HtmlWidget";
import GalleryWidget from "./widgets/gallery/GalleryWidget";

interface IProps {
    content: IWidget;
}

export default function ContentResolver(props: IProps) {
    const { content } = props;

    const { type: contentType, video, textBlock, html, buttons, galleryImages } = content;

    if (contentType === "youtube_video_widget") return <YoutubeVideoWidget video={video} />;
    if (contentType === "text_block_widget") return <TextBlockWidget text={textBlock} />;
    if (contentType === "button_widget") return <ButtonsWidget buttons={buttons} />;
    if (contentType === "html_widget") return <HtmlWidget html={html} />;
    if (contentType === "gallery_widget") return <GalleryWidget images={galleryImages} />;

    return null;
}
